module.exports = __webpack_public_path__ + "img/1269_sprites_serie_a.a1f77682.png";